import { SUBMOTIVE3_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useSubmotive3ListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SUBMOTIVE3_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
